import React from 'react';
import PropTypes from 'prop-types';
import classNames from '@jd/jmtd-tools/es/classnames';
import Checkbox from '../Checkbox';
import FormControl from '../FormControl';
import Icon from '../Icon';
export default function CheckboxControl(_ref) {
  var children = _ref.children,
      size = _ref.size,
      disabled = _ref.disabled,
      checked = _ref.checked,
      className = _ref.className,
      indeterminate = _ref.indeterminate,
      onChange = _ref.onChange,
      uncheckable = _ref.uncheckable,
      id = _ref.id,
      draggable = _ref.draggable;
  return /*#__PURE__*/React.createElement(FormControl, {
    id: id,
    uncheckable: uncheckable,
    checked: checked,
    size: size,
    disabled: disabled,
    className: classNames('jmtd-checkbox-control', className, {
      'jmtd-checkbox-control-draggable': draggable
    }),
    control: /*#__PURE__*/React.createElement("div", {
      className: "jmtd-checkbox-control-content"
    }, draggable && /*#__PURE__*/React.createElement(Icon, {
      className: "jmti-ellopsis-v",
      style: {
        color: '#ACB9DD'
      }
    }), /*#__PURE__*/React.createElement(Checkbox, {
      uncheckable: uncheckable,
      indeterminate: indeterminate,
      onChange: onChange
    }))
  }, children);
}
CheckboxControl.propTypes = {
  id: PropTypes.string,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  className: PropTypes.string,
  size: PropTypes.oneOf(['large', 'middle', 'small', 'mini']),
  disabled: PropTypes.bool,
  children: PropTypes.node,
  indeterminate: PropTypes.bool,
  uncheckable: PropTypes.bool,
  draggable: PropTypes.bool
};
CheckboxControl.defaultProps = {
  id: null,
  checked: false,
  onChange: function onChange() {},
  className: '',
  disabled: false,
  size: null,
  children: null,
  indeterminate: null,
  uncheckable: null,
  draggable: false
};